var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnverifiedBadgeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 5.5,
    r: 5.5,
    fill: "#E78A8A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 0C4.04131 -1.73947e-08 2.64236 0.579463 1.61091 1.61091C0.579463 2.64236 1.27523e-07 4.04131 0 5.5C-1.27523e-07 6.95869 0.579462 8.35764 1.61091 9.38909C2.64236 10.4205 4.04131 11 5.5 11L5.5 5.5V0Z",
    fill: "#E64444"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnverifiedBadgeIcon);
export default __webpack_public_path__ + "static/media/unverified-badge-icon.fbbc4b438752d754571628cbdf235db1.svg";
export { ForwardRef as ReactComponent };